import React, { Fragment } from 'react';
import { connect } from "react-redux";
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Modal from '@material-ui/core/Modal';
import ModalHeading from '../ModalHeading';
import ButtonContent from '../ButtonContent';
import withAuth from '../../hocs/withAuth';
import { COLORS } from '../../styles/colors'
import AddIcon from '@material-ui/icons/Add';
import { Link } from "react-router-dom";
import StartCalendar from "./StartCalendar";
import EndCalendar from "./EndCalendar";
import TreeView from "./TreeView";
import ActionForm from './ActionForm';
import ActionListing from './../assignments/ActionsListing';
import moment from 'moment';
import { AlertJsMessage, ConfirmJsMessage } from './../../helpers.js';
import { range } from 'lodash';

class EditActionPlan extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            show: props.isOpenAddModal,
            formData: {
                title: ''
            },
            selectedTab: 'committedAction',
            actions: [],
            oldActions: [],
            isOpenForm: false
        }
        this.prepareData = [];
    }

    
    componentDidMount() {
        this.fetchActionList([this.props.range._id]);
    }

    makeid(length) {
        var result = '';
        var characters = '0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    handleChange = event => {
		const { name, value } = event.target;
		this.setState({
			formData: {
				...this.state.formData,
				[name]: value,
			},
		});
	};

  
    fetchActionList = (rangeIds) => {
        this.setState({
            actions: []
        })
        this.props.fetchActions(rangeIds)
        .then((res) => {
            const actions = res.data && res.data.data.map((data) => {
                return {
                    path: data.title,
                    type: "tree",
                    _id: data._id,
                    isCompleted: data.isCompleted,
                    isDelete: false,
                    clientId: this.makeid(10),
                    tree: data.subActions.map((data) => {
                        return {
                            path: data.title,
                            _id: data._id,
                            isCompleted: data.isCompleted,
                            clientId: this.makeid(10),
                            isDelete: false,
                        }
                    })
                }
            })
            this.prepareData = actions;
            this.setState({
                actions: actions,
                oldActions: JSON.parse(JSON.stringify(actions))
            })
        })
    }

    onClose = () => this.setState({ show: false }, () => this.props.hideActionModal());

    renderDate = (date) => {
        return moment(date).utc(0, true).format('MM/DD/YYYY');
    }

    passData = (clientId, subData) => {
        let prepareData = this.prepareData;
        const findIndex = prepareData.findIndex((action) => {
            return action.clientId === clientId
        });
        if (findIndex > -1) {
            const tree = prepareData[findIndex]['tree'];
            const subClientId = subData['clientId'];
            const subIndex = tree.findIndex((sub) => {
                return sub.clientId === subClientId
            });
            if (subIndex > -1) {
                tree[subIndex] = subData;
            } else {
                tree.push(subData)
            }
            prepareData[findIndex]['tree']  = tree;
            this.prepareData = prepareData
        }
    }

    addData = () => {
        this.setState({
          isOpenForm: true,
          actionType: 'Action',
          formData: {
              title: ''
          }
        })
    }

    onSave = () => {
        let { formData, actions } = this.state;
        const required = ['title'];
         for (var i = 0; i < required.length; i++) {
             if (!formData[required[i]]) {
                 AlertJsMessage('Action is required.');
                 return;
             }
        }
        if (formData.clientId) {
           const findIndex = actions.findIndex((action) => {
               return action.clientId === formData.clientId
           })
           actions[findIndex] = {
               ...actions[findIndex],
               path: formData.title,
               isDelete: false
           }
        } else {
           actions.push({
             path: formData.title,
             type: "tree",
             tree: [],
             clientId: this.makeid(10),
             isDelete: false
           })
        }
        this.setState({
             actions: [...actions],
             isOpenForm: false,
             formData: {
                 ...formData,
                 clientId: this.makeid(10)
             }
         })
         this.prepareData = actions
     }

    onEditAction = (data) => {
        this.setState({
            isOpenForm: true,
            actionType: 'Action',
            formData: {
                title: data.path,
                _id: data._id,
                clientId: data.clientId
            }
        })
    }

    submitData = () => {
        let prepareData = this.prepareData;
        const rangeDateWithoutZone = moment(this.props.range.startDate).utc(0, true).format('YYYY-MM-DD');
        const a = moment(this.state.startDate);
        const b = moment(rangeDateWithoutZone);
        const diff = a.diff(b, 'days');
        prepareData = prepareData.map((data, index) => {
            let tree = data.tree;
            if (tree.length) {
                tree = tree.map((t,index) => {
                    return {
                        ...t,
                        subOrderId: index+ 1
                    }
                })
            }
            return {
                ...data,
                orderId: index + 1,
                tree: tree
            }
        });
        this.props.saveClientAction({
            _id: this.props.range._id,
            startDate: this.state.startDate,
            endDate: this.state.endDate,
            actions: prepareData,
            clientEmail: this.props.clientEmail,
            isDateChange: diff !== 0,
            isActionChange: JSON.stringify(this.prepareData) !== JSON.stringify(this.state.oldActions)
        })
        .then((res) => {
           this.props.parentData(res.actionRangeDetails)
        })
    }

    onDeleteAction = (clientId) => {
        if (ConfirmJsMessage(`Are you sure you want to delete the action?`)) {
            let { actions } = this.state;
            const findIndex = actions.findIndex((action) => {
                return action.clientId === clientId
            })
            actions[findIndex] = {
                ...actions[findIndex],
                isDelete: true
            }
            this.prepareData = actions
            this.setState({
                actions: [...actions],
            })
        }
    }

    addDays = (dateObj, numDays) => {
        return dateObj.setDate(dateObj.getDate() + numDays);
    }

    changeStartDate = (data) => {
        const date = new Date(data);
        const values = [
            this.addDays(new Date(data), 0),
            this.addDays(new Date(data), 1),
            this.addDays(new Date(data), 2),
            this.addDays(new Date(data), 3),
            this.addDays(new Date(data), 4),
            this.addDays(new Date(data), 5),
            this.addDays(new Date(data), 6),
        ]
        this.setState({
            endDateValues: values,
            startDate: moment(date).format('YYYY-MM-DD'),
            endDate: moment(this.addDays(new Date(data), 6)).format('YYYY-MM-DD')
        })
    }

    render() {
        const { show, actions, actionType, isOpenForm, formData } = this.state;
        let updateActions = actions.filter((action) => !action.isDelete)
        let filterActions = [];
        for(let i = 0; i < updateActions.length; i++) {
            let obj = {
                ...updateActions[i]
            }
            let tree = updateActions[i]['tree'];
            tree = tree.filter((action) => !action.isDelete)
            obj['tree'] = tree;
            filterActions.push(obj);
        }
        const { range } = this.props;

        let startDate = moment(range.startDate).utc(0, true);
        const month = startDate.format('M');
        const day   = startDate.format('D');
        const year  = startDate.format('YYYY');
        startDate = new Date(`${year}-${month}-${day}`)
       
        return (
            <Modal
                className="modal show"
                open={show}
                onClose={this.onClose}
            >
                <div className="modalBody modal-content" style={{ width: 500, minHeight: 500 }}>
                        <Fragment>
                            <ModalHeading
                                text={ `Edit Committed Action` }
                                closeModal={this.onClose}
                            />
                            <div className="modalContent">
                            <Fragment>
                                        <div style={{
                                            display: 'flow-root',
                                            padding: 0,
                                            paddingLeft: 0,
                                            width: '100%',
                                            height: '90px'
                                            }}>
                                            <div style={{
                                                display: 'initial',
                                                float: 'left'
                                            }}>
                                            <p>Start Date</p>
                                                <StartCalendar bottomLeftPosition={true}  startDate={startDate} changeStartDate={this.changeStartDate} showDetailsHandle={this.showDetailsHandle} />
                                            </div>
                                            <div style={{
                                                display: 'initial',
                                                float: 'left',
                                                marginLeft: '10px'
                                            }}>
                                            <p>End Date</p>
                                                <EndCalendar endDateValues={this.state.endDateValues} showDetailsHandle={this.showDetailsHandle} />
                                            </div>
                                        </div>
                                        <div style={{
                                                    marginTop: '0px',
                                                }}>
                                            <Button
                                                color="primary"
                                                startIcon={<AddIcon />}
                                                onClick={() => this.addData()}
                                            >
                                                <ButtonContent text="Add Action" icon="plus"  />
                                            </Button>
                                        </div>
                                    </Fragment>
                                    <Fragment>
                                      {isOpenForm && (
                                        <ActionForm
                                            isEdit={false}
                                            hideAddModal={() => {
                                                this.setState({
                                                    isOpenForm: false
                                                })
                                            }}
                                            isOpenFormModal = {isOpenForm}
                                            onChange={this.handleChange}
                                            actionType = {actionType}
                                            formData={formData}
                                            onSave={() => this.onSave()}
                                        />
                                        )}
                                        {filterActions.map((item, index) => {
                                            return (
                                            <Fragment>
                                                <TreeView 
                                                    onEditAction = {this.onEditAction} 
                                                    key={index}
                                                    onDeleteAction = { this.onDeleteAction }
                                                    passData = { this.passData }
                                                    item = {item}>
                                                </TreeView>
                                            </Fragment>
                                            )
                                        })}
                                         { filterActions.length > 0 &&
                                            <div style={{
                                                        marginTop: '5px',
                                                    }}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={() => this.submitData()}
                                            >
                                                <ButtonContent
                                                    text="Submit"
                                                    icon="chevron-right" />
                                            </Button>
                                            </div>
                                        }
                                    </Fragment>
                                
                            </div>
                        </Fragment>
                </div>
            </Modal>
        )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        errors: state.errors
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {

    }
}
export default connect(mapStateToProps, mapDispatchToProps)(withAuth(EditActionPlan));



// WEBPACK FOOTER //
// ./src/components/assignments/EditActionPlan.js